module.exports = __webpack_public_path__ + "img/mobile/PromoBetBar/panel_background@1x.png?0.0.53";